<script lang="ts">
    let {
        id,
        label,
        bold,
        children,
    }: {
        id?: string;
        label?: string;
        children?: () => any;
        bold?: boolean;
    } = $props();
</script>
{#if bold}
    <label for={id} class="text-xs font-bold text-slate-700">
        {#if children}
            {@render children?.()}
        {:else}
            {label}
        {/if}
    </label>
{:else}
    <label for={id} class="mb-1 ml-1 text-[10px] font-bold uppercase text-slate-700">
        {#if children}
            {@render children?.()}
        {:else}
            {label}
        {/if}
    </label>
{/if}

<style>
    @import "tailwindcss";
</style>
